const lowerOrUppercasePattern = /^(?=.*[a-z])(?=.*[A-Z])/; // checks if string contains uppercase and lowercase letter

export function passContainLowerAndUppercaseLetter(pass: string) {
  return lowerOrUppercasePattern.test(pass);
}
